import { render, staticRenderFns } from "./SecurityPolicy.vue?vue&type=template&id=ab6b5e44&scoped=true"
import script from "./SecurityPolicy.vue?vue&type=script&lang=js"
export * from "./SecurityPolicy.vue?vue&type=script&lang=js"
import style0 from "./SecurityPolicy.vue?vue&type=style&index=0&id=ab6b5e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6b5e44",
  null
  
)

export default component.exports